<payment #paymentComponent
         [showEmail]="false"
         style="visibility: hidden;width:0"
></payment>
<div class="contacts">

  <h2>
    Управление подпиской в библиотеку VARЁNKA
  </h2>

  <div>

    <mat-tab-group
      [(selectedIndex)]="selectedTab"
      [@.disabled]="true"
      [disableRipple]="true"
      [disablePagination]="true"
      [mat-stretch-tabs]="true"


    >
      <mat-tab label="Статус подписки">
        <div class="find-result">
          <div class="subscribe">

            <h3>Введите email</h3>
            <input class="base-input  email"  [(ngModel)]="email"/>
            <button mat-button class="main-button order-button" (click)="checkSubscription()">Проверить</button>

            <div class="subscription-info">
              <div *ngIf="noValidEmail"  class="error">Email не верный</div>
              <div *ngIf="!resultCheck && check">у Вас нет активной подписки</div>
              <div *ngIf="resultCheck && check">
                Ваша подписка действительна
                <span
                  *ngIf="librarySubscription.cancelAt">до {{librarySubscription.cancelAt | unixDate:" dd.MM.yyyy"}}</span>

              </div>
            </div>

          </div>
        </div>
      </mat-tab>
      <mat-tab label="Подписаться">

        <div class="subscribe">

          <h3>Введите email</h3>
          <input class="base-input  email" [(ngModel)]="email"/>
          <h3>Введите Ваше имя</h3>
          <input class="base-input  email" [(ngModel)]="name"/>
          <button mat-button class="main-button order-button" (click)="subscribe()">Подписаться</button>
          <div *ngIf="noValidEmail" class="error">Email не верный</div>
          <div *ngIf="noName" class="error">Введите Ваше имя в поле ввода</div>

        </div>

      </mat-tab>
      <mat-tab label="Отписаться">

        <div class="find-result">

          <div class="subscribe">

            <h3>Введите email</h3>
            <input class="base-input  email"   [(ngModel)]="email"/>
            <button mat-button class="main-button order-button" (click)="unSubscribe()">Отписаться</button>
            <div *ngIf="noValidEmail" class="error">Email не верный</div>
            <div *ngIf="unSubscriptionError" class="error">{{unSubscriptionError}}</div>
            <div *ngIf="unSubscriptionResult" >{{unSubscriptionResult}}</div>


          </div>
        </div>

      </mat-tab>
    </mat-tab-group>
  </div>
</div>
